import { render, staticRenderFns } from "./ClientEditTabInformation.vue?vue&type=template&id=0d9c157b&scoped=true&"
import script from "./ClientEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./ClientEditTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./ClientEditTabInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9c157b",
  null
  
)

export default component.exports